import { render, staticRenderFns } from "./theme-inspector.vue?vue&type=template&id=1adb5d5e&scoped=true&"
import script from "./theme-inspector.vue?vue&type=script&lang=ts&"
export * from "./theme-inspector.vue?vue&type=script&lang=ts&"
import style0 from "./theme-inspector.vue?vue&type=style&index=0&id=1adb5d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adb5d5e",
  null
  
)

export default component.exports